module.exports = __webpack_public_path__ + "static/img/p3.b048992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p3.png
// module id = daEU
// module chunks = 1